import {getUsers} from '../../../entities/selectors'
import {addUsers, setTimeZoneGroupsList, setUserGroupsList} from '../../../entities/actions'
import {getUsersList} from '../common/selectors'
import {addNewUsersToList} from '../common/actions'
import {USERS_WITHOUT_GROUP_ID} from 'constants'

export const updateUsersGroups = (userIdGroupIdMap) => (dispatch, getState) => {
    const state = getState()
    const entitiesUsers = getUsers(state)
    const usersList = getUsersList(state)
    dispatch(addUsers(Object.values(entitiesUsers).map(user => ({...user, userGroupId: userIdGroupIdMap[user.id]}))))
    dispatch(addNewUsersToList(Object.values(usersList).map(user => ({...user, userGroupId: userIdGroupIdMap[user.id]}))))
}

export const updateUsersTimeZoneGroups = (userIdGroupIdMap) => (dispatch, getState) => {
    const state = getState()
    const entitiesUsers = getUsers(state)
    const usersList = getUsersList(state)
    dispatch(addUsers(Object.values(entitiesUsers).map(user => ({...user, timeZoneGroupId: userIdGroupIdMap[user.id]}))))
    dispatch(addNewUsersToList(Object.values(usersList).map(user => ({...user, timeZoneGroupId: userIdGroupIdMap[user.id]}))))
}

export const updateDepartments = (departments) => (dispatch) => {
    let departmentsInfo = departments
        .filter(d => d.getId() !== USERS_WITHOUT_GROUP_ID)
        .map(d => {
            return {
                id: d.getId(),
                name: d.getName()
            }
        })

    dispatch(setUserGroupsList(departmentsInfo))
}

export const updateTimeZoneGroups = (timeZoneGroups) => (dispatch) => {
    let tzgInfo = timeZoneGroups
        .filter(g => g.id !== USERS_WITHOUT_GROUP_ID)
        .map(g => {
        return {
            id: g.id,
            name: g.name,
            rawOffset: g.rawOffset,
        }
    })

    dispatch(setTimeZoneGroupsList(timeZoneGroups))
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/groupManagement/actions.js